import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CountryCheck" })
export default class CountryCheck extends Vue {
    public localizer: any = Localizer;
    public isContryConfirmed: boolean = true;
    public country: string = null;

    @Prop() readonly countryCode: string;

    get isLanguageSelectorVisible() {
        return this.$store.getters["languageSelectorStore/isLanguageSelectorVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (!window.localStorage.getItem("countryConfirmed")) {
            const result = (await Axios.post(this.routes.Geo_GetCountries)).data;
            this.country = result.find(x => x.code === this.countryCode).title;
        }

        this.isContryConfirmed = window.localStorage.getItem("countryConfirmed") ? true : false;
    }

    public setCountry() {
        this.isContryConfirmed = true;
        GTagHelper.sendEvent("click", "country_check", "confirm");
        window.localStorage.setItem("countryConfirmed", "true");
    }

    public setCatalogue() {
        GTagHelper.sendEvent("click", "country_check", "modify");
        window.localStorage.setItem("countryConfirmed", "true");
        this.isContryConfirmed = true;
        this.$store.commit("languageSelectorStore/setLanguageSelectorVisible", true);
    }
};